import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { CirclePicker } from 'react-color'

export default class WorkFlowStep extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            workFlowId: props.WorkFlowId,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/solution/workflow/step/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.deadlineDay)) this.state.data.record.deadlineDay = 0;
        if (this.isBlank(this.state.data.record.step)) this.state.data.record.step = 0;

        this.httpPost("api/v1/solution/workflow/step/save", {
            id: this.state.id,
            workFlowId: this.state.workFlowId,
            title: this.state.data.record.title,
            description: this.state.data.record.description,
            parameter: this.state.data.record.parameter,
            nextStepMode: this.state.data.record.nextStepMode,
            deadlineDay: parseInt(this.state.data.record.deadlineDay),
            step: parseInt(this.state.data.record.step),
            hasRequirementPricing: this.state.data.record.hasRequirementPricing,
            canReject: this.state.data.record.canReject,
            canUserAsign: this.state.data.record.canUserAsign,
            canChangeStep: this.state.data.record.canChangeStep,
            color: this.state.data.record.color,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleChangeComplete = (color) => {
        this.state.data.record.color = color.hex;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات مرحله کاری" : "افزودن مرحله کاری جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">پارامتر</label>
                                            <input defaultValue={this.state.data.record.parameter} onChange={e => this.state.data.record.parameter = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <input defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">شماره گام</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.step} onChange={e => this.state.data.record.step = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">مهلت انجام(روز)</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.deadlineDay} onChange={e => this.state.data.record.deadlineDay = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">گام بعدی</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.nextStepMode} onChange={e => this.state.data.record.nextStepMode = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value="1">نیازمند تایید تمام مجریان و مسئولین</option>
                                                <option value="2">با تایید اولین مجری و مسئول</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">برآورد مالی نیازمندی ها</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.hasRequirementPricing ? "1" : "0"} onChange={e => this.state.data.record.hasRequirementPricing = e.target.value == "1"} className="form-control input-sm">
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">امکان عدم تایید و برگشت به عقب</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.canReject ? "1" : "0"} onChange={e => this.state.data.record.canReject = e.target.value == "1"} className="form-control input-sm">
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">امکان انتخاب مسئول گام بعدی</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.canUserAsign ? "1" : "0"} onChange={e => this.state.data.record.canUserAsign = e.target.value == "1"} className="form-control input-sm">
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">امکان تغییر گام توسط مسئول</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.canChangeStep ? "1" : "0"} onChange={e => this.state.data.record.canChangeStep = e.target.value == "1"} className="form-control input-sm">
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">رنگ زمینه کارت</label>
                                            <CirclePicker
                                                color={this.state.data.record.color}
                                                onChangeComplete={this.handleChangeComplete}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}